import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';

export default function SaltLibrary(): JSX.Element {
  useEffect(() => {
    setWindowTitle('Salt Library');
  }, []);
  return <div>Salt Library</div>;
}
